
import React from 'react';
import OptimizedFinanceProcurementList from './OptimizedFinanceProcurementList';

const FinanceApprovalsRejected = () => {
  return <OptimizedFinanceProcurementList status="rejected" />;
};

export default FinanceApprovalsRejected;
